import React from "react";
import { connect } from 'react-redux';
import axios from 'axios';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';

import {getCurrentUserSuccess} from '../../actions/session';
import NotificaionsForm from './NotificaionsForm';
import { getHeader } from "../../helper";

class Notificaions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            formEdit: false,
            checkChanged: false,

            is_notification_push_new_order: '',
            is_notification_push_change_order: '',
            is_notification_push_new_message: '',
            is_notification_email_new_order: '',
            is_notification_email_change_order: '',
            is_notification_email_new_message: '',
            is_notification_sms_new_order: '',
            is_notification_sms_change_order: '',
            is_notification_sms_new_message: '',
        }
    }

    componentDidMount() {
        this.setCurrentData();
    }

    setCurrentData() {
        const {currentUser} = this.props.session;

        this.setState({
            is_notification_push_new_order: currentUser.is_notification_push_new_order,
            is_notification_push_change_order: currentUser.is_notification_push_change_order,
            is_notification_push_new_message: currentUser.is_notification_push_new_message,
            is_notification_email_new_order: currentUser.is_notification_email_new_order,
            is_notification_email_change_order: currentUser.is_notification_email_change_order,
            is_notification_email_new_message: currentUser.is_notification_email_new_message,
            is_notification_sms_new_order: currentUser.is_notification_sms_new_order,
            is_notification_sms_change_order: currentUser.is_notification_sms_change_order,
            is_notification_sms_new_message: currentUser.is_notification_sms_new_message,
        });
    }

    onEdit(save = false) {
        if(this.state.formEdit && save === false)
            this.setCurrentData();

        this.setState({
            formEdit: !this.state.formEdit,
            checkChanged: false,
        });
    }

    handleOnChange(value, field) {
        this.setState({
            [field]: value,
            checkChanged: true
        })
    }

    onSubmit(){

        if(!this.state.checkChanged) {
            Alert.error('Изменений нет', {
                position: 'bottom-left',
                effect: 'stackslide',
                timeout: 5000
            });
            return;
        }
        
        const { currentUser, token } = this.props.session;

        const payload = {
            is_notification_push_new_order: this.state.is_notification_push_new_order,
            is_notification_push_change_order: this.state.is_notification_push_change_order,
            is_notification_push_new_message: this.state.is_notification_push_new_message,
            is_notification_email_new_order: this.state.is_notification_email_new_order,
            is_notification_email_change_order: this.state.is_notification_email_change_order,
            is_notification_email_new_message: this.state.is_notification_email_new_message,
            is_notification_sms_new_order: this.state.is_notification_sms_new_order,
            is_notification_sms_change_order: this.state.is_notification_sms_change_order,
            is_notification_sms_new_message: this.state.is_notification_sms_new_message,
        };
        
        axios.patch(
            `${window.siteUrl}/api/v1/user/${currentUser.id}/`,
            payload,
            {
                headers: getHeader()
            }
        )
        .then(response => {
            this.setState({
                checkChanged: false
            }, () => {
                Alert.success('Изменения сохранены', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            });

            this.props.getCurrentUserSuccess(payload)
            this.onEdit(true)
        })
        .catch(error=> {
            console.error(" error", error);
        });
    }

    render()  {
        return (
            <div className="right-content native-scroll right-content-bottom right-content-width">
                <div className="screen-outer-block-wrap native-scroll menu-content">
                    <div className="menu-content-notificaions menu-content-item tab-parent screen-center-block">

                        <Alert stack={{limit: 1}} />

                        <div className="rounded-white-block">

                            <NotificaionsForm
                                {...this.state}
                                onSubmit={() => this.onSubmit()}
                                onEdit={() => this.onEdit()}
                                handleOnChange={(value, field) => this.handleOnChange(value, field)}
                                />

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        session: state.session
    }),
    {
        getCurrentUserSuccess
    }
)(Notificaions);


// WEBPACK FOOTER //
// ./src/components/Account/Notificaions.js